// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { ThumbnailsList, Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGridL2SThumbnailsList = class TeaserBoxInnerGridL2SThumbnailsList extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.listConfig = {
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
        this.tileConfig = {
            [TileSize.S]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showCategory: false,
                showAuthorAvatar: false,
                showAuthorName: false,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.S,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            },
            [TileSize.L]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showCategory: this.teaserBoxConfig.showCategory,
                showAuthorAvatar: this.teaserBoxConfig.showAuthorAvatar,
                showAuthorName: this.teaserBoxConfig.showAuthorName,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.L,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            }
        };
        this.TileSize = TileSize;
    }
};
TeaserBoxInnerGridL2SThumbnailsList.moduleVersion = TeaserBoxVersion['L-2S-thumbnails-list'];
TeaserBoxInnerGridL2SThumbnailsList = __decorate([
    Component({
        name: 'TeaserBoxInnerGridL2SThumbnailsList',
        components: { InnerGridWrapper, ThumbnailsList, Tile },
        template: `
    <InnerGridWrapper>
      <template v-if="articles && articles.length">
        <!-- Tile / L -->
        <Tile v-bind="{ ...tileConfig[TileSize.L], fallbackImage, windowService, isLazy, isMobile }" :article="articles[0]" />

        <!-- Tiles / S -->
        <Tile v-for="article in articles.slice(1, 3)" :key="article.id"
              v-bind="{ ...tileConfig[TileSize.S], article, fallbackImage, windowService, isLazy, isMobile }" />

        <!-- ThumbnailsList -->
        <div class="teaser-box__list-wrapper">
          <ThumbnailsList v-bind="{ readMoreLink, fallbackImage, listConfig, windowService, isLazy, isMobile }" :articles="articles.slice(3, 9)" />
        </div>
      </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGridL2SThumbnailsList);
export { TeaserBoxInnerGridL2SThumbnailsList };
